// extracted by mini-css-extract-plugin
module.exports = {"container":"e_MB","sizeSmall":"e_NB","on":"e_OB","handle":"e_PB","variantGrey":"e_QB","variantPrimary":"e_RB"};